<template>
  <base-top-dialog
    :session-dialog="sessionDialog"
    v-slot:default="{
      overlay,
      visibleFor,
      message,
      clear,
      makeCall,
      processing,
    }"
  >
    <div id="top-dialog" :class="{ [overlayCssClass]: overlay }">
      <div
        class="dialog alert"
        :class="{ [visibleCssClass]: visibleFor('alert') }"
        v-html="message"
        @click="clear"
      ></div>
      <div
        class="dialog warning"
        :class="{ [visibleCssClass]: visibleFor('warning') }"
        v-html="message"
        @click="clear"
      ></div>
      <div
        class="dialog confirm"
        :class="{ [visibleCssClass]: visibleFor('confirm') }"
      >
        <p class="mb-4" v-html="message"></p>
        <nav class="text-sm">
          <span
            class="px-3 py-2 bg-red-700 text-white cursor-pointer"
            v-if="!processing"
            @click="makeCall"
          >
            YES
          </span>
          <span
            class="px-3 py-2 bg-red-700 text-white opacity-50 cursor-default"
            v-if="processing"
          >
            <svg
              class="inline-block mr-1 h-4 w-4 rotate"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 20 20"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 14a4 4 0 110-8 4 4 0 010 8zM9 1a1 1 0 112 0v2a1 1 0 11-2 0V1zm6.65 1.94a1 1 0 111.41 1.41l-1.4 1.4a1 1 0 11-1.41-1.41l1.4-1.4zM18.99 9a1 1 0 110 2h-1.98a1 1 0 110-2h1.98zm-1.93 6.65a1 1 0 11-1.41 1.41l-1.4-1.4a1 1 0 111.41-1.41l1.4 1.4zM11 18.99a1 1 0 11-2 0v-1.98a1 1 0 112 0v1.98zm-6.65-1.93a1 1 0 11-1.41-1.41l1.4-1.4a1 1 0 111.41 1.41l-1.4 1.4zM1.01 11a1 1 0 110-2h1.98a1 1 0 110 2H1.01zm1.93-6.65a1 1 0 111.41-1.41l1.4 1.4a1 1 0 11-1.41 1.41l-1.4-1.4z"
              />
            </svg>
            YES
          </span>
          <span
            class="px-3 py-2 bg-green-dark text-white cursor-pointer ml-2"
            @click="clear"
          >
            NO
          </span>
        </nav>
      </div>
    </div>
  </base-top-dialog>
</template>
<script>
import BaseTopDialog from '@ssdcode/vue-form/src/components/Dialogs/BaseTopDialog';
export default {
  name: 'TopDialog',
  components: { BaseTopDialog },
  props: {
    sessionDialog: {
      type: Object,
      default: () => {
        return {};
      },
    },
    overlayCssClass: {
      type: String,
      default: 'overlay',
    },
    visibleCssClass: {
      type: String,
      default: 'active',
    },
  },
};
</script>
